import cloneDeep from 'lodash/cloneDeep';
import { defaultProps } from './defaultEventProps';
import { getValidatedEventData } from "../eventDataValidator";

export const marketsView = ({title}) => {
    const eventProps = cloneDeep(defaultProps);

    return {
        name: `View Markets Summary - ${title}`,
        details: eventProps,
    };
};

export const marketNewsArticleView = (props) => {
    const {
        newsId,
        newsName
    } = props;

    const eventProps = cloneDeep(defaultProps);

    const propsMapping = [
        {name: 'Market News ID', value: newsId},
        {name: 'Market News Name', value: newsName},
    ];

    eventProps.baseProps = getValidatedEventData({eventData: propsMapping});
    eventProps.providerProps.superProps.incrementalProps['Read Market News'] = 1;

    return {
        name: 'View Market News',
        details: eventProps,
    };
};
